(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutria-card-drawer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('nutria-cart-drawer')) return;

    /* Liquid cannot hold a literal double brace inside a javascript
       block, so the money format token is assembled from parts. */
    var OPEN = '{' + '{', CLOSE = '}' + '}';
    var fallback = '$' + OPEN + 'amount' + CLOSE;
    var re = new RegExp(OPEN + '\\s*(\\w+)\\s*' + CLOSE);

    function money(cents, format) {
      var value = cents / 100;
      var m = re.exec(format || fallback); var key = m ? m[1] : 'amount';
      var num = function (v, dec, thou, decSep) {
        var p = v.toFixed(dec).split('.');
        p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
        return p.length > 1 ? p.join(decSep) : p[0];
      };
      var out;
      switch (key) {
        case 'amount_no_decimals': out = num(value, 0, ',', '.'); break;
        case 'amount_with_comma_separator': out = num(value, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': out = num(value, 0, '.', ','); break;
        case 'amount_with_space_separator': out = num(value, 2, ' ', ','); break;
        case 'amount_no_decimals_with_space_separator': out = num(value, 0, ' ', ','); break;
        case 'amount_with_apostrophe_separator': out = num(value, 2, "'", '.'); break;
        default: out = num(value, 2, ',', '.');
      }
      return (format || fallback).replace(re, out);
    }

    class NutriaCartDrawer extends HTMLElement {
      connectedCallback() {
        this.format = this.dataset.moneyFormat;
        this.threshold = parseInt(this.dataset.threshold || '0', 10);
        this.autoOpen = this.dataset.autoOpen === 'true';
        this.fetchCompare = this.dataset.fetchCompare === 'true';
        this.requireLocker = this.dataset.requireLocker === 'true';
        this.root = (this.dataset.localeRoot || '/').replace(/\/?$/, '/');
        this.compareCache = {};
        this.lastFetch = 0;
        this.inflight = null;
        this.pending = false;
        this.panel = this.querySelector('.ncd__panel');
        this.itemsEl = this.querySelector('[data-ncd-items]');
        this.tpl = this.querySelector('[data-ncd-item-template]');
        this.cart = null;

        this.querySelectorAll('[data-ncd-close]').forEach((b) => b.addEventListener('click', () => this.close()));
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); });

        /* Open from the header cart icon, which links to /cart once the
           theme cart type is Page, and from anything marked data-ncd-open. */
        document.addEventListener('click', (e) => {
          var t = e.target.closest('[data-ncd-open], a[href="/cart"], a[href$="/cart"], [href*="/cart?"]');
          if (!t || t.closest('nutria-cart-drawer')) return;
          e.preventDefault(); e.stopPropagation();
          this.toggle();
        }, true);

        /* Horizon's cart events, whichever name this version uses */
        var onCart = (e) => {
          var d = e.detail || {};
          var src = (d.data && d.data.source) || d.source || '';
          var isAdd = e.type === 'cart:add' || d.action === 'add' || /product-form|quick-add|buy/i.test(src);
          var done = () => {
            if (isAdd && this.autoOpen) this.open({ refresh: false });
            this.refresh();
          };
          if (e.promise && e.promise.then) e.promise.then(done).catch(done); else done();
        };
        ['cart:update', 'cart:add', 'shopify:cart:lines-update', 'ncd:refresh'].forEach((n) => document.addEventListener(n, onCart));

        /* Event names vary by Horizon version and add source, so also
           watch the network. Every add, change and update the theme
           makes goes through fetch to /cart/*.js, including quick-add
           and the bundle builder. This is the reliable path. */
        var self = this;
        var origFetch = window.fetch;

        /* The drawer's own requests use the untouched fetch, so a quantity
           click does not trigger a second refresh through the interceptor. */
        this.net = origFetch.bind(window);

        window.fetch = function (input, init) {
          var url = typeof input === 'string' ? input : (input && input.url) || '';
          var p = origFetch.apply(this, arguments);
          if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
            var isAdd = /\/cart\/add/.test(url);
            p.then(function (res) {
              if (!res || !res.ok) return;
              /* Open the moment the add succeeds. The cart fills in while
                 the panel slides, instead of the customer waiting on a
                 second request before anything moves. */
              if (isAdd && self.autoOpen) self.open({ refresh: false });
              self.refresh();
            }).catch(function () {});
          }
          return p;
        };

        this.querySelectorAll('[data-ncd-add]').forEach((b) => b.addEventListener('click', () => this.add(b.dataset.ncdAdd, b)));

        this.initLocker();

        window.NutriaCart = { open: () => this.open(), close: () => this.close(), toggle: () => this.toggle(), refresh: () => this.refresh() };
        this.refresh();
      }

      /* ---------- state ---------- */

      open(opts) {
        if (this.classList.contains('is-open')) return;
        this.adoptBoxNow();
        /* Only fetch on open if the cart is stale. After an add the caller
           refreshes itself, and a header click right after a page load
           already has fresh data. */
        var wantRefresh = !(opts && opts.refresh === false);
        if (wantRefresh && Date.now() - this.lastFetch > 1500) this.refresh();
        this.classList.add('is-open');
        document.body.classList.add('ncd-locked');
        this.panel && this.panel.focus();
      }
      close() { this.classList.remove('is-open'); document.body.classList.remove('ncd-locked'); }
      toggle() { this.classList.contains('is-open') ? this.close() : this.open(); }

      /* Several things can ask for a refresh at once: the network
         interceptor, Horizon's cart events, loyalty and upsell apps that
         write to the cart. Only one request runs at a time. Anything that
         arrives mid flight is folded into a single follow up, so the last
         state always wins without a pile of parallel cart.js calls. */
      refresh() {
        if (this.inflight) { this.pending = true; return this.inflight; }
        this.classList.add('is-loading');
        this.inflight = (async () => {
          try {
            do {
              this.pending = false;
              var r = await this.net(this.root + 'cart.js', { headers: { Accept: 'application/json' } });
              this.cart = await r.json();
              this.lastFetch = Date.now();
              this.render();
            } while (this.pending);
            document.dispatchEvent(new CustomEvent('ncd:updated', { detail: { cart: this.cart } }));
          } catch (e) {
            console.warn('[ncd] refresh failed', e);
          } finally {
            this.inflight = null;
            this.classList.remove('is-loading');
          }
        })();
        return this.inflight;
      }

      async change(key, quantity, el) {
        el && el.classList.add('is-busy');
        try {
          var r = await this.net(this.root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: key, quantity: quantity })
          });
          this.cart = await r.json();
          this.lastFetch = Date.now();
          this.render();
          document.dispatchEvent(new CustomEvent('ncd:updated', { detail: { cart: this.cart } }));
        } catch (e) { console.warn('[ncd] change failed', e); el && el.classList.remove('is-busy'); }
      }

      async add(variantId, btn) {
        var orig = btn ? btn.textContent : '';
        btn && (btn.disabled = true);
        try {
          await this.net(this.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
          });
          await this.refresh();
          if (btn) { btn.textContent = this.dataset.addedLabel || 'Added'; setTimeout(() => { btn.textContent = orig; btn.disabled = false; }, 1400); }
        } catch (e) { btn && (btn.disabled = false); }
      }

      /* Compare at prices are not in cart.js, so each product is fetched
         once and cached. This used to run inside render, one product at a
         time, and the drawer waited for all of them before it opened.
         Logged in customers skip Shopify's edge cache, which made each of
         those requests slower still. Now the cart paints straight away
         with what it has, the missing prices load in parallel, and the
         lines update once they arrive. */
      loadCompare() {
        if (!this.fetchCompare || !this.cart) return;
        var handles = {};
        this.cart.items.forEach((it) => {
          if (it.handle && this.compareCache[it.variant_id] === undefined) handles[it.handle] = it.variant_id;
        });
        var list = Object.keys(handles);
        if (!list.length) return;

        /* Mark as requested so overlapping renders do not fetch twice */
        list.forEach((h) => { this.compareCache[handles[h]] = this.compareCache[handles[h]] ?? null; });

        Promise.all(list.map((h) =>
          this.net(this.root + 'products/' + h + '.js')
            .then((r) => r.json())
            .then((p) => { p.variants.forEach((v) => { this.compareCache[v.id] = v.compare_at_price || 0; }); })
            .catch(() => { this.compareCache[handles[h]] = 0; })
        )).then(() => this.render({ skipCompare: true }));
      }

      compareFor(item) {
        var v = this.compareCache[item.variant_id];
        return typeof v === 'number' ? v : 0;
      }

      /* ---------- render ---------- */

      render(opts) {
        var c = this.cart; if (!c) return;
        var count = c.item_count;

        var countEl = this.querySelector('[data-ncd-count]'); var countWrap = this.querySelector('[data-ncd-count-wrap]');
        if (countEl) countEl.textContent = count; if (countWrap) countWrap.hidden = count === 0;
        document.querySelectorAll('.cart-bubble__text-count, [data-ncd-cart-count]').forEach((el) => { el.textContent = count; el.classList.toggle('hidden', count === 0); });
        document.querySelectorAll('.cart-bubble').forEach((el) => el.classList.toggle('visually-hidden', count === 0));

        var empty = this.querySelector('[data-ncd-empty]'); var foot = this.querySelector('[data-ncd-foot]'); var upsell = this.querySelector('[data-ncd-upsell]');
        if (empty) empty.hidden = count > 0; if (foot) foot.hidden = count === 0;

        this.itemsEl.innerHTML = '';
        var savings = 0;
        for (var item of c.items) {
          var node = this.tpl.content.firstElementChild.cloneNode(true);
          node.dataset.key = item.key;
          node.querySelectorAll('[data-ncd-item-url]').forEach((a) => (a.href = item.url));

          var img = node.querySelector('[data-ncd-item-img]');
          if (item.image) { img.src = item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2'); img.alt = item.product_title; } else img.remove();

          node.querySelector('[data-ncd-item-title]').textContent = item.product_title;

          var meta = [];
          if (item.variant_title && item.variant_title !== 'Default Title') meta.push(item.variant_title);
          if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) meta.push(item.selling_plan_allocation.selling_plan.name);
          if (item.properties) Object.keys(item.properties).forEach((k) => { if (!k.startsWith('_') && item.properties[k]) meta.push(k + ': ' + item.properties[k]); });
          node.querySelector('[data-ncd-item-meta]').textContent = meta.join(' · ');

          /* quantity tier badge, from the automatic discount title */
          var badge = node.querySelector('[data-ncd-item-badge]');
          var disc = (item.discounts && item.discounts[0]) || (item.line_level_discount_allocations && item.line_level_discount_allocations[0] && item.line_level_discount_allocations[0].discount_application);
          if (disc && disc.title) { badge.hidden = false; badge.textContent = disc.title; }

          var priceEl = node.querySelector('[data-ncd-item-price]');
          var cmpEl = node.querySelector('[data-ncd-item-compare]');
          priceEl.textContent = money(item.final_line_price, this.format);
          var compareUnit = this.compareFor(item);
          var original = Math.max(item.original_line_price, compareUnit * item.quantity);
          if (original > item.final_line_price) {
            cmpEl.hidden = false; cmpEl.textContent = money(original, this.format);
            savings += original - item.final_line_price;
          }

          node.querySelector('[data-ncd-qty-value]').textContent = item.quantity;
          node.querySelector('[data-ncd-qty-minus]').addEventListener('click', ((it, n) => () => this.change(it.key, it.quantity - 1, n))(item, node));
          node.querySelector('[data-ncd-qty-plus]').addEventListener('click', ((it, n) => () => this.change(it.key, it.quantity + 1, n))(item, node));
          node.querySelector('[data-ncd-remove]').addEventListener('click', ((it, n) => () => this.change(it.key, 0, n))(item, node));
          this.itemsEl.appendChild(node);
        }

        if (upsell) {
          var inCart = new Set(c.items.map((i) => String(i.product_id)));
          var visible = 0;
          upsell.querySelectorAll('[data-ncd-upsell-item]').forEach((card) => {
            var hide = inCart.has(card.dataset.productId);
            card.hidden = hide; if (!hide) visible++;
          });
          upsell.hidden = visible === 0 || count === 0;
        }

        var totalTxt = money(c.total_price, this.format);
        var ckTotal = this.querySelector('[data-ncd-checkout-total]'); if (ckTotal) ckTotal.textContent = totalTxt;

        var savRow = this.querySelector('[data-ncd-savings-row]'); var savEl = this.querySelector('[data-ncd-savings]');
        var totalSavings = Math.max(savings, c.total_discount || 0);
        if (savRow) { savRow.hidden = totalSavings <= 0; if (savEl) savEl.textContent = money(totalSavings, this.format); }

        var ship = this.querySelector('[data-ncd-ship]');
        if (ship && this.threshold > 0) {
          var remaining = this.threshold - c.total_price;
          var pct = Math.min(100, Math.round((c.total_price / this.threshold) * 100));
          var fill = this.querySelector('[data-ncd-ship-fill]'); var txt = this.querySelector('[data-ncd-ship-text]');
          fill && fill.style.setProperty('--p', pct + '%');
          ship.classList.toggle('ncd__ship--done', remaining <= 0);
          if (txt) txt.innerHTML = remaining <= 0 ? this.msg('unlocked') : this.msg('remaining').replace('[amount]', '<b>' + money(remaining, this.format) + '</b>');
        }

        this.adoptBoxNow();
        this.applyLockerGate();

        if (!(opts && opts.skipCompare)) this.loadCompare();
      }

      msg(k) { return this.getAttribute('data-msg-' + k) || (k === 'unlocked' ? 'FREE Shipping Unlocked!' : 'You are [amount] away from FREE Shipping'); }

      /* ---------- BoxNow locker slot and gate ----------

         The app should inject into [data-ncd-boxnow] once its selector
         is set to .ncd__boxnow. Some builds render before this element
         exists and fall back to the body, so anything of the app's
         found elsewhere is adopted into the slot. Only leaf controls
         move; their wrapper stays put so any modal it holds is never
         dragged along.

         Selection is read from the element before the remove button,
         which the app fills with the locker name and empties on
         unselect. The slot is observed so the gate reacts the moment
         the app writes to it. */

      adoptBoxNow() {
        var slot = this.lockerSlot; if (!slot) return;
        var isIn = (el) => el && slot.contains(el);

        var sel = document.querySelector('select[class*="tp-"], [class*="tp-"] select');
        if (sel && !isIn(sel)) {
          var w = sel.parentElement;
          var small = w && /(^|\s)tp-/.test(w.className || '') && w.children.length <= 2;
          slot.appendChild(small ? w : sel);
        }

        var choose = [...document.querySelectorAll('button, a')].find((e) =>
          /locker/i.test(e.textContent || '') &&
          !/unselect/i.test(e.textContent || '') &&
          !isIn(e) && !e.closest('.ncd__checkout')
        );
        if (choose) slot.appendChild(choose);

        var rem = document.querySelector('.tp-drawer-locker-remove-button');
        if (rem && !isIn(rem)) {
          var name = rem.previousElementSibling;
          if (name) slot.appendChild(name);
          slot.appendChild(rem);
        }
      }

      initLocker() {
        this.lockerSlot = this.querySelector('[data-ncd-boxnow]');
        this.lockerWarn = this.querySelector('[data-ncd-locker-warn]');
        this.checkoutBtn = this.querySelector('[data-ncd-checkout]');
        if (!this.lockerSlot) return;

        var queued = false;
        var mo = new MutationObserver(() => {
          if (queued) return; queued = true;
          requestAnimationFrame(() => { queued = false; this.applyLockerGate(); });
        });
        mo.observe(this.lockerSlot, { childList: true, subtree: true, characterData: true });

        /* The app renders on its own schedule, so look for stray output
           a few times over the first seconds. */
        var tries = 0;
        var timer = setInterval(() => {
          this.adoptBoxNow(); this.applyLockerGate();
          if (++tries >= 12) clearInterval(timer);
        }, 750);

        this.adoptBoxNow();
        this.applyLockerGate();
      }

            lockerName() {
        var slot = this.lockerSlot; if (!slot) return '';

        /* Everything before the choose button is the country control.
           Everything after it that is not a control is the app's
           confirmation, which holds the locker name once chosen. */
        var choose = [...slot.querySelectorAll('button, a')].find((e) => !/unselect/i.test(e.textContent || ''));
        if (!choose) return '';

        var text = '';
        var passed = false;
        slot.querySelectorAll('*').forEach((el) => {
          if (el === choose || choose.contains(el)) { passed = true; return; }
          if (!passed) return;
          if (el.children.length) return;
          if (el.closest('button, a, select, label, .ncd__locker-warn')) return;
          text += ' ' + (el.textContent || '');
        });

        /* Style whatever the app printed, best effort */
        var rem = slot.querySelector('.tp-drawer-locker-remove-button');
        if (rem && rem.previousElementSibling) rem.previousElementSibling.classList.add('ncd__locker-name');

        /* Drop the app's fixed sentence, leaving only the locker name */
        return text.replace(/^[\s\S]*?locker:\s*/i, '').trim();
      }

      applyLockerGate() {
        if (!this.checkoutBtn) return;
        if (!this.requireLocker || !this.lockerSlot) {
          this.checkoutBtn.removeAttribute('disabled');
          if (this.lockerWarn) this.lockerWarn.hidden = true;
          return;
        }
        var ok = this.lockerName().length > 0;
        if (ok) { this.checkoutBtn.removeAttribute('disabled'); this.checkoutBtn.removeAttribute('aria-disabled'); }
        else { this.checkoutBtn.setAttribute('disabled', 'disabled'); this.checkoutBtn.setAttribute('aria-disabled', 'true'); }
        if (this.lockerWarn && this.lockerWarn.hidden !== ok) this.lockerWarn.hidden = ok;
      }
    }

    customElements.define('nutria-cart-drawer', NutriaCartDrawer);
  })();

  } catch(e) { console.error(e); }
})();
})();
